const conjunctions = {
  de: {
    coordinate: [
      {
        id: '1',
        term: 'aber',
        description1: 'but, however',
        description2: 'Du hast Hunger aber du isst nicht.',
      },
      {
        id: '2',
        term: 'beziehungsweise',
        description1: 'better put, respectively',
        description2: 'Ein Auto habe ich beziehungsweise meine Frau hat eins.',
      },
      {
        id: '3',
        term: 'denn',
        description1: 'because, then',
        description2: 'Sie hat geweint, denn sie kein Geld gehabt.',
      },
      {
        id: '4',
        term: 'oder',
        description1: 'or',
        description2: 'Ich kann mit dem Auto nach Hamburg fahren oder ich kann fliegen.',
      },
      {
        id: '5',
        term: 'sondern',
        description1: 'but, but rather',
        description2: 'Der Apfel ist nicht rot, sondern grün.',
      },
      {
        id: '6',
        term: 'und',
        description1: 'and',
        description2: 'Daleks sind gefährlich und sie sind böse.',
      },
    ],
    subordinate: [
      {
        id: '1',
        term: 'als',
        description1: 'when',
        description2: 'Als ich fünf Jahre alt war, habe ich Schule begonnen.',
      },
      {
        id: '2',
        term: 'bevor',
        description1: 'before',
        description2: 'Ich muss nach Hause gehen, bevor ich einschlafe.',
      },
      {
        id: '3',
        term: 'bis',
        description1: 'until',
        description2: 'Ich warte auf dich, bis ich müde bin.',
      },
      {
        id: '4',
        term: 'damit',
        description1: 'so that',
        description2: 'Marta isst Eier, damit sie kein Hunger hat.',
      },
      {
        id: '5',
        term: 'dass',
        description1: 'that',
        description2: 'Du denkst, dass Donald ein Idiot ist.',
      },
      {
        id: '6',
        term: 'nachdem',
        description1: 'after',
        description2: 'Nachdem wir der Zombie gesehen haben, sind wir weg gerannt.',
      },
      {
        id: '7',
        term: 'ob',
        description1: 'whether, if',
        description2: 'Ich weiß nicht, ob er reich ist.',
      },
      {
        id: '8',
        term: 'obwohl',
        description1: 'although',
        description2: 'Stewart ist ziemlich reich, obwohl er sehr billig ist.',
      },
      {
        id: '9',
        term: 'seit',
        description1: 'since',
        description2: 'Ich wohne in Köln, seit ich geboren bin.',
      },
      {
        id: '10',
        term: 'seitdem',
        description1: 'since',
        description2: 'Ich habe keine Heizung, seitdem ich in Spanien wohne.',
      },
      {
        id: '11',
        term: 'sobald',
        description1: 'as soon as',
        description2: 'Ich wird Deutschland gehen, sobald ich mehr Geld habe.',
      },
      {
        id: '12',
        term: 'sofern',
        description1: 'provided that, as long as',
        description2: 'Wir schwimmen, sofern es nicht regnet.',
      },
      {
        id: '13',
        term: 'soviel',
        description1: 'as much as, for all',
        description2: 'Soviel ich weiß, ist sie ein Kobold.',
      },
      {
        id: '14',
        term: 'soweit',
        description1: 'as far as',
        description2: 'Soweit du weißt, ist er der Teufel.',
      },
      {
        id: '15',
        term: 'sowie',
        description1: 'as soon as',
        description2: 'Ich gebe dir das Geld, sowie du einundzwanzig bist.',
      },
      {
        id: '16',
        term: 'während',
        description1: 'while, during',
        description2: 'Ich habe Niederländisch studiert, während ich Deutsch studiert habe.',
      },
      {
        id: '17',
        term: 'weil',
        description1: 'because',
        description2: 'Ich trinke Tee, weil ich keinen Kaffee mag.',
      },
      {
        id: '18',
        term: 'wenn',
        description1: 'if, ',
        description2: 'Wenn es warm ist, gehe ich oft schwimmen.',
      },
      {
        id: '19',
        term: 'wie',
        description1: 'how',
        description2: 'Du weißt nicht, wie verrückt sie ist.',
      },
      {
        id: '20',
        term: 'wo',
        description1: 'where',
        description2: 'Ich weiß nicht, wo dein Monsterbuch ist.',
      },
    ],
    compound: [
      {
        id: '1',
        term: 'anstatt ... zu',
        description1: 'instead of [subordinate]',
        description2: '',
      },
      {
        id: '2',
        term: 'entweder ... oder',
        description1: 'either... or [coordinate]',
        description2: '',
      },
      {
        id: '3',
        term: 'weder noch',
        description1: 'neither... nor [coordinate]',
        description2: '',
      },
      {
        id: '4',
        term: 'weder noch',
        description1: 'as well as [subordinate]',
        description2: '',
      },
      {
        id: '5',
        term: 'sowohl ... als (auch)',
        description1: 'as well as [subordinate]',
        description2: '',
      },
      {
        id: '6',
        term: 'sowohl ... wie (auch)',
        description1: 'as well as [subordinate]',
        description2: '',
      },
    ],
  },
  nl: {
    coordinate: [
      {
        id: '1',
        term: 'en',
        description1: 'and',
        description2: 'Ik eet brood en ik drink melk.',
      },
      {
        id: '2',
        term: 'maar',
        description1: 'but',
        description2: 'Ik drink bier, maar ik drink ook wijn.',
      },
      {
        id: '3',
        term: 'of',
        description1: 'or',
        description2: 'Eet hij koekjes of eet hij cake?',
      },
      {
        id: '4',
        term: 'dus',
        description1: 'so',
        description2: 'Het regent dus we gaan naar het binnenzwembad.',
      },
      {
        id: '5',
        term: 'want',
        description1: 'as',
        description2: 'Ik eet geen noten want ik heb een allergie.',
      },
    ],
    subordinate: [
      {
        id: '1',
        term: 'als',
        description1: 'if, when',
        description2: '',
      },
      {
        id: '2',
        term: 'alsof',
        description1: 'as if',
        description2: '',
      },
      {
        id: '3',
        term: 'behalve dat',
        description1: 'except that',
        description2: '',
      },
      {
        id: '4',
        term: 'hoewel',
        description1: 'although',
        description2: '',
      },
      {
        id: '5',
        term: 'inzover(re) dat',
        description1: 'to the extent that',
        description2: '',
      },
      {
        id: '6',
        term: 'nu(dat)',
        description1: 'now',
        description2: '',
      },
      {
        id: '7',
        term: 'of',
        description1: 'whether',
        description2: '',
      },
      {
        id: '8',
        term: 'omdat',
        description1: 'because',
        description2: '',
      },
      {
        id: '9',
        term: 'na(dat)',
        description1: 'after',
        description2: '',
      },
      {
        id: '10',
        term: 'sinds',
        description1: 'since',
        description2: '',
      },
      {
        id: '11',
        term: 'tenzij',
        description1: 'unless',
        description2: '',
      },
      {
        id: '12',
        term: 'terwijl',
        description1: 'while',
        description2: '',
      },
      {
        id: '13',
        term: 'toen',
        description1: 'when (in past)',
        description2: '',
      },
      {
        id: '14',
        term: 'tot(dat)',
        description1: 'until',
        description2: '',
      },
      {
        id: '15',
        term: 'wanneer',
        description1: 'when',
        description2: '',
      },
      {
        id: '16',
        term: 'voor(dat)',
        description1: 'before, ',
        description2: '',
      },
      {
        id: '17',
        term: 'zoals',
        description1: 'just',
        description2: '',
      },
      {
        id: '18',
        term: 'zodat',
        description1: 'so dat',
        description2: '',
      },
      {
        id: '19',
        term: 'zolang',
        description1: 'as long as',
        description2: '',
      },
      {
        id: '20',
        term: 'zonder dat',
        description1: 'without',
        description2: '',
      },
      {
        id: '21',
        term: 'zover',
        description1: 'as far as',
        description2: '',
      },
    ],
    compound: [
      {
        id: '1',
        term: 'anstatt ... zu',
        description1: 'instead of [subordinate]',
        description2: '',
      },
      {
        id: '2',
        term: 'entweder ... oder',
        description1: 'either... or [coordinate]',
        description2: '',
      },
      {
        id: '3',
        term: 'weder noch',
        description1: 'neither... nor [coordinate]',
        description2: '',
      },
      {
        id: '4',
        term: 'weder noch',
        description1: 'as well as [subordinate]',
        description2: '',
      },
      {
        id: '5',
        term: 'sowohl ... als (auch)',
        description1: 'as well as [subordinate]',
        description2: '',
      },
      {
        id: '6',
        term: 'sowohl ... wie (auch)',
        description1: 'as well as [subordinate]',
        description2: '',
      },
    ],
  },
  za: {
    coordinate: [
      {
        id: '1',
        term: 'aber',
        description1: 'but, however',
        description2: '',
      },
      {
        id: '2',
        term: 'beziehungsweise',
        description1: 'better put, respectively',
        description2: '',
      },
      {
        id: '3',
        term: 'denn',
        description1: 'because, then',
        description2: '',
      },
      {
        id: '4',
        term: 'oder',
        description1: 'or',
        description2: '',
      },
      {
        id: '5',
        term: 'sondern',
        description1: 'but, but rather',
        description2: '',
      },
      {
        id: '6',
        term: 'und',
        description1: 'and',
        description2: '',
      },
    ],
    subordinate: [
      {
        id: '1',
        term: 'als',
        description1: 'when',
        description2: '',
      },
      {
        id: '2',
        term: 'bevor',
        description1: 'before',
        description2: '',
      },
      {
        id: '3',
        term: 'bis',
        description1: 'until',
        description2: '',
      },
      {
        id: '4',
        term: 'damit',
        description1: 'so that',
        description2: '',
      },
      {
        id: '5',
        term: 'dass',
        description1: 'that',
        description2: '',
      },
      {
        id: '6',
        term: 'nachdem',
        description1: 'after',
        description2: '',
      },
      {
        id: '7',
        term: 'ob',
        description1: 'whether, if',
        description2: '',
      },
      {
        id: '8',
        term: 'obwohl',
        description1: 'although',
        description2: '',
      },
      {
        id: '9',
        term: 'seitdem',
        description1: 'since',
        description2: '',
      },
      {
        id: '10',
        term: 'sobald',
        description1: 'as soon as',
        description2: '',
      },
      {
        id: '11',
        term: 'sofern',
        description1: 'provided that, as long as',
        description2: '',
      },
      {
        id: '12',
        term: 'soweit',
        description1: 'insofar as',
        description2: '',
      },
      {
        id: '13',
        term: 'sowie',
        description1: 'as soon as',
        description2: '',
      },
      {
        id: '14',
        term: 'während',
        description1: 'while',
        description2: '',
      },
      {
        id: '15',
        term: 'weil',
        description1: 'because',
        description2: '',
      },
      {
        id: '16',
        term: 'wenn',
        description1: 'if, ',
        description2: '',
      },
      {
        id: '17',
        term: 'wie',
        description1: 'how',
        description2: '',
      },
      {
        id: '18',
        term: 'wo',
        description1: 'where',
        description2: '',
      },
    ],
    compound: [
      {
        id: '1',
        term: 'anstatt ... zu',
        description1: 'instead of [subordinate]',
        description2: '',
      },
      {
        id: '2',
        term: 'entweder ... oder',
        description1: 'either... or [coordinate]',
        description2: '',
      },
      {
        id: '3',
        term: 'weder noch',
        description1: 'neither... nor [coordinate]',
        description2: '',
      },
      {
        id: '4',
        term: 'weder noch',
        description1: 'as well as [subordinate]',
        description2: '',
      },
      {
        id: '5',
        term: 'sowohl ... als (auch)',
        description1: 'as well as [subordinate]',
        description2: '',
      },
      {
        id: '6',
        term: 'sowohl ... wie (auch)',
        description1: 'as well as [subordinate]',
        description2: '',
      },
    ],
  },
};

export default conjunctions;
